import { CSSInterpolation } from "@emotion/css/dist/declarations/src/create-instance";


import { Theme } from '@mui/material/styles'
export const AssignmentProjectCreateBasicInfoStlye: (theme: Theme) => Record<string, CSSInterpolation> = (theme) => ({
	root: {
		width: '100%',
		textAlign: 'left',
	},
	topBarInner: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		height: "60px",
		borderBottom: '1px solid #e5e5e5',
		padding: '0px 20px',
		background: '#eee',
	},
	topBarTitle: {
		'&.MuiTypography-root': {
			fontSize: '1rem',
			fontWeight: 'bold',
			color: '#6F6E75',
			letterSpacing: '-0.5px'
			// marginLeft: "10px",
		}
	},
	iconBtnReset: {
		'&.MuiIconButton-root': {
			padding: 0,
			'&:hover': {
				background: 'transparent'
			},
		}
	},
	selectPopover: {
		left: '11px !important',
		'& .MuiMenu-list': {
			height: '280px'
		},
		'& .MuiMenuItem-root': {
			'&:first-child': {
				display: 'none'
			},
		}
	},
	moreMenu: {
		border: '1px solid #CBCBCB',
		borderRadius: 3,
		width: "36px",
		height: "36px",
		marginRight: "25px",

	},
	iconButton: {
		'&.MuiIconButton-root': {
			marginLeft: "20px",
		}
	},
	iconToggle: {
		'&.MuiIconButton-root': {
			margin: 10,
		}
	},
	iconDailog: {
		'&.MuiIconButton-root': {
			margin: 10,
			marginLeft: "30px",
		}
	},
	topBarMenu: {
		'& .MuiTypography-root': {
			color: '#2F80ED',
			fontSize: '1rem',
			fontWeight: 600,
			textDecoration: 'underline',
			letterSpacing: '-0.5px',
			marginTop: "3px",
		}
	},


	topBar: {
		'&.MuiToolbar-root': {
			borderBottom: '1px solid #e5e5e5',
			minHeight: 54,
		}
	},
	barTest: {
		'&.MuiDrawer-paper': {
			visibility: 'visible'
		}
	},
	listButton: {
		'&.MuiListItemButton-root': {
			justifyContent: 'center',
			padding: '5px 16px',
		},
		'&.MuiListItemButton-root:hover': {
			padding: '5px 16px',
			background: '#fff'
		},
		'& .MuiListItemText-root': {
			marginLeft: "20px",
		}
	},
	listIcon: {
		'&.MuiListItemIcon-root': {
			minWidth: 'auto',
		},

	},

	/////////////////////
	sideBarContent: {
		width: '200px',
		borderRight: '1px solid #e5e5e5',
		height: 'calc(100vh - 61px)',
	},
	sideBarOpenStyle: {
		'& .MuiDrawer-paper': {
			width: "210px",
			height: 'calc(100vh - 55px)',
			marginTop: "55px",
		}
	},
	sideBarCloseStyle: {
		'& .MuiDrawer-paper': {
			width: "60px",
			height: 'calc(100vh - 55px)',
			marginTop: "55px",
		}
	},





	/////////////////////
	padding: {
		padding: 15,
	},
	mainContentBox: {
		border: '1px solid #EAECEB',
		padding: '22px 31px',
		height: 'calc(100vh - 85px)',
		overflowY: 'auto',
		background: '#fff',
		width: '100%',
		maxWidth: 1024,
		boxSizing: 'border-box'
	},
	mainContentBoxLeft: {
		border: '1px solid #CBCBCB',
		padding: 20,
		height: 'calc(100vh - 130px)',
		overflowY: 'auto',
		background: '#fff',
		width: 'calc(100vw - 770px)',
	},
	mainContentBoxRight: {
		border: '1px solid #CBCBCB',
		padding: 20,
		height: 'calc(100vh - 90px)',
		overflowY: 'auto',
		background: '#fff',
		width: '620px',
		boxSizing: 'border-box',
		marginLeft: "10px",
	},
	commonTopTitle: {
		marginTop: "12px",
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: "20px",
	},
	commonMainTitle: {
		textAlign: 'left',
		'&.MuiTypography-root': {
			fontSize: '1.5rem',
			fontWeight: 700,
			letterSpacing: '-0.5px',
			lineHeight: 'normal',

			'& span': {
				color: '#008C73'
			}
		}
	},


	commonSubTitle: {
		marginBottom: "15px",
		textAlign: 'left',
		'&.MuiTypography-root': {
			fontSize: '1.25rem',
			fontWeight: 700,
			letterSpacing: '-0.5px',
			lineHeight: 'normal',
			'& span': {
				color: '#008C73'
			}
		}
	},
	schoolNameBox: {
		background: '#F3F3F3',
		padding: '30px 35px',
	},
	schoolName: {
		'&.MuiTypography-root': {
			fontSize: '1.125rem',
			fontWeight: 'bold',
			color: '#111',
			marginBottom: "20px",
		}
	},
	schoolNameSubText: {
		color: '#555',
		fontSize: '1rem',
		letterSpacing: '-0.5px',
		marginBottom: "15px",
	},
	dialogInput: {
		position: 'relative',
		width: '100%',
		'& .MuiFormControl-root': {
			width: '100%',
			height: "46px",
			boxSizing: 'border-box',
			background: '#fff',
		},
		'& .MuiOutlinedInput-root': {
			height: "84px",
			borderColor: '#cbcbcb',
			borderRadius: 3,
			'&.Mui-focused fieldset': {
				borderColor: '#2F80ED',
			},
		},
		'& .MuiOutlinedInput-input': {
			padding: '9px 100px 9px 0px',
		},
		'& .MuiPaper-elevation1': {
			border: '1px solid #CBCBCB',
			boxShadow: 'none'
		}
	},
	basicInputBox: {
		'& .MuiFormControl-root': {
			height: "140px",
		},
		'& .MuiOutlinedInput-root': {
			height: 140
		},
		'& .MuiOutlinedInput-input': {
			height: '110px !important'
		}
	},
	basicInputBox2: {
		'& .MuiFormControl-root': {
			height: "40px",
		},
		'& .MuiOutlinedInput-root': {
			height: 40
		},
		'& .MuiOutlinedInput-input': {
			height: '40px !important',
			padding: '9px 100px 9px 9px'
		}
	},
	dialogInputMulti: {
		'& .MuiFormControl-root': {
			height: "220px",
		},
		'& .MuiOutlinedInput-root': {
			height: 220
		},
	},
	countPosition: {
		marginRight: "10px",
		position: 'absolute',
		right: 0,
		top: 10,
	},
	countNum: {
		'&.MuiTypography-root': {
			color: '#787878',
			fontSize: '0.875rem',
			marginRight: "10px",
		}
	},




	greenBtn: {
		'&.MuiButtonBase-root': {
			width: "100px",
			height: "36px",
			background: '#cdcdcd',
			'&:hover': {
				background: '#cdcdcd',
			},
			'& .MuiTypography-root': {
				color: '#888',
				fontWeight: 'bold'
			}
		}
	},
	greenBtnActive: {
		'&.MuiButtonBase-root': {
			width: "100px",
			height: "36px",
			background: '#008c73',
			'&:hover': {
				background: '#008c73',
			},
			'& .MuiTypography-root': {
				color: '#fff',
				fontWeight: 'bold'
			}
		}
	},

	// lineBtn: {
	//     '&.MuiButtonBase-root': {
	//         width: "100px",
	//         height: "36px",
	//         background: '#fff',
	//         border: '1px solid #cdcdcd',
	//         '&:hover': {
	//             background: '#fff',
	//         },
	//         '& .MuiTypography-root': {
	//             color: '#888',
	//             fontWeight: 'bold'
	//         }
	//     }
	// },
	// lineBtnActive: {
	//     '&.MuiButtonBase-root': {
	//         width: "100px",
	//         height: "36px",
	//         background: '#fff',
	//         border: '1px solid #CBCBCB',
	//         '&:hover': {
	//             background: '#fff',
	//         },
	//         '& .MuiTypography-root': {
	//             color: '#2F80ED',
	//             fontWeight: 'bold'
	//         }
	//     }
	// },

	saveBtn: {
		marginRight: "10px",
		'&.MuiButtonBase-root': {
			width: "100px",
			height: "36px",
			background: '#fff',
			borderRadius: 3,
			border: '1px solid #cbcbcb',
			'&:hover': {
				background: '#fff',
			},
			'& .MuiTypography-root': {
				color: '#008c73',
				fontWeight: 700,
				letterSpacing: '-0.5px',
			}
		},
		'&.Mui-disabled': {
			opacity: 0.5,
			border: '1px solid rgba(0, 0, 0, 0.12)',
			'& .MuiTypography-root': {
				color: 'rgba(0, 0, 0, 0.26)',
			},
		}
	},
	nextBtn: {
		'&.MuiButtonBase-root': {
			width: "100px",
			height: "36px",
			background: '#008c73',
			borderRadius: 3,
			border: '1px solid #008c73',
			'&:hover': {
				background: '#008c73',
			},
			'& .MuiTypography-root': {
				color: '#fff',
				fontWeight: 'bold',
				letterSpacing: '-0.5px',
			}
		},
		'&.Mui-disabled': {
			opacity: 0.5,
			border: '1px solid rgba(0, 0, 0, 0.12)',
			'& .MuiTypography-root': {
				color: 'rgba(0, 0, 0, 0.26)',
			},
		}
	},
	calendarLineBtn: {
		'&.MuiButtonBase-root': {
			width: "100px",
			height: "36px",
			background: '#fff',
			border: '1px solid #CBCBCB',
			'&:hover': {
				background: '#fff',
			},
			'& .MuiTypography-root': {
				color: '#2F80ED',
				fontWeight: 'bold',
				fontSize: '1em'
			}
		}
	},
	selectText: {
		'&.MuiTypography-root': {
			color: '#111',
			fontWeight: 'bold',
			marginRight: "15px",
		}
	},

	formControl: {
		'&.MuiFormControl-root': {
			margin: 0,
			width: "300px",
			marginRight: "12px",
		},
		'& .MuiSelect-select': {
			width: "300px",
			height: "36px",
			padding: '14px 25px 15px 12px !important',
			fontSize: '1rem',
			boxSizing: 'border-box',
			color: '#777',
			letterSpacing: '-0.5px',
			display: 'flex',
			alignItems: 'center',
			background: '#fff',
			border: 'solid 1px #cbcbcb',
			borderRadius: '2px !important',
			'& em': {
				fontStyle: 'normal !important',
				color: '#787878',
				letterSpacing: '-0.8px',
			},
			'@media all and (max-width: 800px)': {
				width: '100%',
			},
		},
		'& .MuiOutlinedInput-root.Mui-focused .MuiSelect-select': {
			border: '0px solid rgba(117, 0, 250, 0.4)',
			padding: '13px 25px 14px 12px !important',
		},
		'& .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
			border: 0,
			borderRadius: 3,
		},
		'& .MuiInput-underline:after, .MuiInput-underline:before': {
			border: 0,
		},
		'& .MuiInput-underline:hover:not(.Mui-disabled):before': {
			border: 0,
		},
		'& .MuiSelect-icon': {
			top: 14,
			right: 11,
		},
	},
	formControlWidth: {
		'&.MuiFormControl-root': {
			width: "50px",
			height: "30px",
			marginRight: "5px",
			marginLeft: "5px",
		},
		'& .MuiSelect-select': {
			width: "50px",
			height: "30px",
			padding: '14px 25px 15px 9px !important',
			borderRadius: '4px !important',
		},
		'& .MuiSelect-icon': {
			top: 12,
			right: 7
		}
	},



	moreListBtn: {
		marginTop: "10px",
		'& .MuiButtonBase-root': {
			background: 'transparent',
			'& hover': {
				background: 'transparent'
			},
			'& svg': {
				marginLeft: "5px",
			}
		},
		'& .MuiTypography-root': {
			color: '#008C73',
			fontSize: '0.875rem'
		}
	},
	pageNumber: {
		marginTop: "20px",
		'& .MuiPaginationItem-root': {
			'&.Mui-selected': {
				background: '#008C73',
				color: '#fff',
				border: '1px solid #008C73',
				borderRadius: '100%'
			},
		},
		'& .MuiPaginationItem-root:hover': {
			background: '#fff',
			border: '1px solid #008C73',
			color: '#008C73',
			fontWeight: 'bold',
			borderRadius: '100%'
		}
	},

	checkBoxStyle: {
		'& .MuiCheckbox-colorSecondary.Mui-checked': {
			color: '#2F80ED',
			'& .MuiIconButton-colorSecondary:hover': {
				background: 'transparent'
			}
		},
		'& .MuiIconButton-colorSecondary:hover': {
			background: 'transparent'
		},
		'& .MuiTypography-root': {
			color: '#555',
			fontWeight: 400,
			letterSpacing: '-0.5px'
		}
	},
	tableStudentNameBtn: {
		'&.MuiButtonBase-root': {
			background: 'transparent',
			'& hover': {
				background: 'transparent',
			},
			'& .MuiTypography-root': {
				color: '#008C73',
				fontSize: '0.875rem',
				textDecoration: 'underline',
				letterSpacing: '-0.5px'
			}
		}

	},
	tableBox: {
		marginTop: "20px",
		'&.MuiPaper-root': {
			borderTop: '1px solid rgba(119, 119, 119, 0.7)',
			boxShadow: 'none',
			borderRadius: 0,
			'& table': {
				tableLayout: 'fixed'
			},
			'& .MuiTableCell-head': {
				fontSize: '0.875rem',
				color: '#555',
				letterSpacing: '-0.5px',
				padding: '0 5px',
				boxSizing: 'border-box',
				height: "50px",
				borderBottom: '1px solid rgba(119, 119, 119, 0.7)',
				'& span': {
					fontSize: '0.875rem',
					fontWeight: 'normal'
				},
				'@media all and (max-width: 1550px)': {
					fontSize: '0.875rem',
					'& span': {
						fontSize: '0.688rem',
					}
				},
			},
			'& .MuiTableCell-body': {
				fontSize: '0.875rem',
				color: '#323232',
				height: "50px",
				letterSpacing: '-0.5px',
				padding: '0 5px',
				boxSizing: 'border-box',
				borderBottom: '1px solid rgba(55, 39, 39, 0.7)',
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				whiteSpace: 'nowrap',
				'@media all and (max-width: 1550px)': {
					fontSize: '0.875rem',
				},
			}
		}
	},

	schoolText: {
		border: '1px solid #CBCBCB',
		background: '#F3F3F3',
		padding: 10,
		textAlign: 'center',
		borderRadius: '5px 0px 0px 5px',
		width: "80px",
		boxSizing: 'border-box'
	},

	schoolNameText: {
		border: '1px solid #CBCBCB',
		borderLeft: '0px',
		background: '#DEF8F3',
		padding: '10px 20px',
		borderRadius: '0px 5px 5px 0px',
		width: "240px",
		boxSizing: 'border-box',
		'&.MuiTypography-root': {
			fontWeight: 'bold'
		}
	},
	iconAdd: {
		'& svg': {
			marginBottom: "2px",
			marginRight: "5px",
		}
	},

	stepOpen: {
		'&.MuiButtonBase-root': {
			border: '1px solid #111',
			width: "120px",
			boxSizing: 'border-box',
			background: '#fff',
			color: '#111',
			'&:hover': {
				background: '#fff',
			},
			'& .MuiTypography-root': {
				fontSize: '0.813rem',
				fontWeight: 'bold',
			}
		}
	},
	taskSave: {
		'&.MuiButtonBase-root': {
			border: '1px solid #E97C17',
			color: '#E97C17',
		}
	},
	taskMark: {
		'&.MuiButtonBase-root': {
			border: '1px solid #7730BA',
			color: '#7730BA',
		}
	},
	taskResult: {
		'&.MuiButtonBase-root': {
			border: '1px solid #3850D5',
			color: '#3850D5',
		}
	},



	numberBox: {
		width: "41px",
		height: "27px",
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: 13,
		background: '#eee',
		boxSizing: 'border-box',
		marginRight: "11px",
		'& p': {
			fontSize: '0.875rem',
			color: '#777',
			fontWeight: 'bold',
			'& span': {
				color: '#38cb89',
				fontWeight: 'bold'
			}
		}
	},
	progressBox: {
		width: "80px",
		'& .MuiLinearProgress-root': {
			height: "6px",
			background: '#eee',
			borderRadius: 3
		},
		'& .MuiLinearProgress-bar': {
			background: '#38cb89'
		}
	},
	progressText: {
		'&.MuiTypography-root': {
			fontSize: '0.875rem',
			color: '#323232',
			marginLeft: "11px",
			'@media all and (max-width: 1550px)': {
				fontSize: '0.75rem',
			},
		}
	},

	popoverBox: {
		'& .MuiPaper-root': {
			width: "120px",
			boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.25)',
			border: '1px solid #bbb',
			borderRadius: 6,
			'& ul': {
				padding: '4px 0',
				'& li': {
					color: '#6f6f6f',
					letterSpacing: '-0.5px',
					display: 'flex',
					justifyContent: 'center',
					'& .MuiTypography-root': {
						marginLeft: "6px",
						fontSize: '0.875rem',
					},
					'&:hover': {
						background: '#eee'
					},
				},
			},
			'& *': {
				fontFamily: 'Pretendard-Regular !important',
			},
		}
	},
	deleteText: {
		'&.MuiTypography-root': {
			color: 'red'
		},
	},




	taskOpenDialog: {
		'& .MuiPaper-root': {
			width: "785px",
			height: '90vh',
			borderRadius: '15px'
		},
		'& .MuiDialog-paperWidthSm': {
			maxWidth: 785,
		}
	},

	mainTitle: {
		'&.MuiTypography-root': {
			fontSize: '1.5rem',
			fontWeight: 700,
			letterSpacing: '-0.5px',
			color: '#111',
			marginLeft: "20px",
		},
	},
	dialogContent: {
		padding: '0px 20px 30px 20px',
		marginBottom: "30px",
		marginTop: "40px",
	},
	dialogHalf: {
		maxWidth: '720px',
		width: '100%'
	},
	dialogTitle: {
		'&.MuiTypography-root': {
			fontSize: '1.125rem',
			fontWeight: 700,
			letterSpacing: '-0.5px',
			color: '#111',
			marginBottom: "20px",
			marginTop: "30px",
			'& span': {
				fontSize: '1rem',
				fontWeight: 'normal',
				color: '#555'
			}
		}
	},
	dialogTitleOnline: {
		'&.MuiTypography-root': {
			fontSize: '1.125rem',
			fontWeight: 'bold',
			marginBottom: "10px",
			marginTop: "30px",
			'& span': {
				fontSize: '1rem',
				fontWeight: 'normal',
				color: '#555'
			}
		}
	},
	dialogSubTitle: {
		'&.MuiTypography-root': {
			fontSize: '1rem',
			color: '#555',
			marginBottom: "20px",
		}
	},

	timeCalendarBox: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'left',
		marginTop: "10px",
	},
	dialogTime: {
		'&.MuiTypography-root': {
			fontSize: '1rem',
			color: '#111',
			fontWeight: 500,
			marginLeft: "10px",
			marginRight: "10px",
		}
	},

	dialogBtnGroup: {
		marginTop: "30px",
		marginBottom: "30px",
	},
	dialogBtn: {
		'&.MuiButtonBase-root': {
			border: '1px solid #CBCBCB',
			width: "120px",
			height: "40px",
		},
		'&.MuiButton-root:hover': {
			background: '#fff'
		},
		'& .MuiTypography-root': {
			color: '#2F80ED',
			fontSize: '1rem',
			fontWeight: 'bold'
		}
	},
	dialogBtnSave: {
		'&.MuiButtonBase-root': {
			border: '1px solid #2F80ED',
			background: '#2F80ED',
			width: "120px",
			height: "40px",
			marginLeft: "15px",
		},
		'&.MuiButton-root:hover': {
			background: '#2F80ED'
		},
		'& .MuiTypography-root': {
			color: '#fff',
			fontSize: '1rem',
			fontWeight: 'bold'
		}
	},
	dialogEduYear: {
		position: 'relative',
		marginRight: "20px",
		'& .MuiFormControl-root': {
			width: '300px',
			height: "36px",
			boxSizing: 'border-box',
			background: '#fff',
		},
		'& .MuiOutlinedInput-root': {
			height: 64
		},
		'& .MuiOutlinedInput-input': {
			padding: '9px 10px',
		}
	},
	dialogYear: {
		position: 'relative',
		marginRight: "10px",
		'& .MuiFormControl-root': {
			width: '110px',
			height: "36px",
			boxSizing: 'border-box',
			background: '#fff',
		},
		'& .MuiOutlinedInput-root': {
			height: 64
		},
		'& .MuiOutlinedInput-input': {
			padding: '9px 10px',
		}
	},
	yearSelectIcon: {
		position: 'absolute',
		right: 0,
		top: 5,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center'
	},
	iconYearSelect: {
		'&.MuiIconButton-root': {
			margin: '4px 5px',
		}
	},

	dateBox: {
		'& .MuiStack-root': {
			paddingTop: 0,
			// paddingBottom: 28,
			display: 'flex',
			alignItems: 'center',
			overflow: 'unset'
		},
		'& .MuiFormControl-root': {
			minWidth: '180px !important',
			maxWidth: '180px !important',
			margin: 0
		},
		'& .MuiInputBase-root': {
			paddingRight: 0,
			borderRadius: 6
		},
		'& .MuiInputBase-input': {
			height: "30px",
			boxSizing: 'border-box',
			fontSize: '0.875rem',
			color: '#323232',
			letterSpacing: '-0.5px',
			fontWeight: 500,
			padding: '0 15px 0 35px',
			textAlign: 'right',
			border: '1px solid #cbcbcb',
		},
		'& .MuiInput-underline:before': {
			borderBottom: '0px',
		},
		'& .MuiInputAdornment-root': {
			position: 'absolute',
			'& .MuiButtonBase-root': {
				padding: 0,
				marginRight: "5px",
				'&:hover': {
					background: 'transparent'
				}
			},
		},
		'& .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
			border: 'solid 1px #cbcbcb',
			borderRadius: 3
		},
		'& .MuiMultiSectionDigitalClock-root': {
			maxHeight: '50px',
		},
	},


	// calendarBox:{
	//     cursor:'pointer',
	//     width: "23px",
	//     height: "23px",
	//     marginRight: "5px",
	//     position: 'absolute',
	//     left: 5,
	//     '& .MuiMultiSectionDigitalClock-root': {
	//         maxHeight: '50px',
	//     }
	// },


	waveText: {
		'&.MuiTypography-root': {
			marginLeft: "10px",
			marginRight: "10px",
		}
	},

	subSideMenu: {
		'& .MuiStepIcon-root.MuiStepIcon-active': {
			color: '#025949'
		},
		'& .MuiStepIcon-root.MuiStepIcon-completed': {
			color: '#025949'
		},
		'& .MuiStepIcon-root': {
			color: '#DDDDDD'
		},
		'& .MuiStepConnector-vertical': {
			padding: '0px 0 2px',
			marginLeft: "6px",
		},
		'& .MuiStepLabel-root': {
			'& .MuiStepLabel-vertical': {

			}
		},
		'& .MuiStepper-vertical': {
			padding: '24px 0px 24px 24px'
		},
		'& .Mui-disabled': {
			'& rect': {
				fill: '#ddd'
			}
		},
		'& .MuiStepLabel-labelContainer': {
			textAlign: 'left'
		}
	},
	nameSearchBtn: {
		'&.MuiButtonBase-root': {
			'&:hover': {
				background: '#fff',
			},
			'& .MuiTypography-root': {
				fontSize: '0.875rem',
				fontWeight: 'bold',
				color: '#787878',
				marginLeft: "5px",
			}
		}
	},

	sortButton: {
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		'& p': {
			fontSize: '1rem',
			color: '#555',
			marginRight: "4px",
			marginLeft: "10px",
		}
	},
	urlInputBox: {
		'& .MuiInputBase-root': {
			width: '100%'
		},
	},
	startDay: {
		position: 'absolute',
		top: '-18px',
		'&.MuiTypography-root': {
			fontSize: '0.75rem',
			color: '#555'
		}
	},
	endDay: {
		position: 'absolute',
		top: '-18px',
		'&.MuiTypography-root': {
			fontSize: '0.75rem',
			color: '#555'
		}
	},
	timeBox: {
		padding: '0px 25px 10px 25px',
	},
	toggleBtnBox: {
		'& .MuiButtonBase-root': {
			width: "45px",
			height: "32px",
			fontSize: '0.813rem',
			border: '1px solid #878787'
		},
		'& .MuiToggleButton-root.Mui-selected': {
			fontWeight: 700
		}
	},
	tooltipBtn: {
		'& .MuiButtonBase-root': {
			padding: 0,
			minWidth: 'auto',
			width: '20px',
			marginRight: '11px',
			'&:hover': {
				background: 'transparent'
			}
		}
	},
	calendarTooltipBtn: {
		marginBottom: '-15px',
		'& .MuiButtonBase-root': {
			padding: 0,
			minWidth: 'auto',
			width: '40px',
			marginRight: '25px',
			marginTop: '4px',
			'&:hover': {
				background: 'transparent'
			}
		}
	},
	dialogInputCalendar: {
		position: 'relative',
		'& .MuiFormControl-root': {
			width: '200px',
			height: "36px",
			boxSizing: 'border-box',
			background: '#fff',
		},
		'& .MuiOutlinedInput-root': {
			height: "36px",
			color: 'rgba(0, 0, 0, 0.38)',
			'&.Mui-focused fieldset': {
				borderColor: '#2F80ED',
			},
		},
		'& .MuiOutlinedInput-input': {
			padding: '9px 10px 9px 10px',
		},
		'& .MuiPaper-elevation1': {
			border: '1px solid #CBCBCB',
			boxShadow: 'none'
		}
	},
	endDatetimeAlert: {
		height: '17px',
		marginLeft: '330px',
		'& .MuiTypography-root': {
			fontSize: '0.875rem',
			color: '#F00',
		}
	},
	disabledMenuItem: {
		display: 'none'
	},
	startCalendar: {
		marginTop: '32px'
	},
	endCalendar: {
		marginTop: '48px'
	},
	assignmentType: {
		marginTop: "20px",
		minHeight: '37px',
		backgroundColor: 'rgba(205, 215, 225, 0.50)',
		padding: 13,
		boxSizing: 'border-box',
		borderRadius: 2,
		'& .MuiTypography-root': {
			fontSize: '0.875rem',
			color: '#555',
			letterSpacing: '-0.5px',
			fontWeight: 400,
		}
	},

	titleBox: {
		display: 'flex',
		alignItems: 'center',
		width: "670px",
		boxSizing: 'border-box',
	},
	contBox: {
		marginTop: "40px",
	},
	titleBox2: {
		width: "670px",
		boxSizing: 'border-box',
		marginBottom: "20px",

	},
	basicTitleBox: {
		display: 'flex',
		alignItems: 'center',
	},
	basicTitleBoxTop: {
		display: 'flex',
		alignItems: 'flex-start',
	},
	basicTitleBoxTop2: {
		display: 'flex',
		alignItems: 'center',
	},
	basicTitle: {
		'&.MuiTypography-root': {
			fontSize: '1.125rem',
			fontWeight: 700,
			color: '#111',
			letterSpacing: '-0.5px',
			width: "160px",
			marginRight: "60px",
		}
	},
	basicText: {
		'&.MuiTypography-root': {
			fontSize: '1rem',
			fontWeight: 500,
			color: '#111',
			letterSpacing: '-0.5px',
		}
	},
	basicContent: {
		width: '100%',
		marginBottom: "40px",
	},
	titleList: {
		'&.MuiTypography-root': {
			fontSize: '1rem',
			fontWeight: 500,
			color: '#111',
			letterSpacing: '-0.5px',
			marginRight: "60px",
			'& span': {
				fontWeight: 700,
			}
		}
	},
	radioGroupBtn: {
		'& .MuiTypography-root': {
			fontSize: '1rem',
			fontWeight: 400,
			color: '#555',
			letterSpacing: '-0.5px',
			marginRight: "45px",
		},
		'& .MuiRadio-colorSecondary.Mui-checked': {
			color: '#2F80ED'
		},
		'& .MuiRadio-colorSecondary': {
			padding: 0,
			marginRight: "5px",
		},
		'& .MuiFormControlLabel-root': {
			marginLeft: "0px",
		}
	}
});












